import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! I will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const contactInfo = [
    {
      icon: "fa-envelope",
      title: "Email",
      value: "mimounisirine348@email.com",
      link: "mailto:mimounisirine348@email.com",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: "fa-phone",
      title: "Phone",
      value: "+216 58 086 751",
      link: "tel:+21658086751",
      color: "from-green-500 to-green-600"
    },
    {
      icon: "fa-map-marker-alt",
      title: "Location",
      value: "Manouba, Tunisia",
      link: "#",
      color: "from-red-500 to-red-600"
    },
    {
      icon: "fa-linkedin",
      title: "LinkedIn",
      value: "mimouni-sirine",
      link: "https://www.linkedin.com/in/mimouni-sirine/",
      color: "from-blue-600 to-blue-700"
    }
  ];

  return (
    <section id="contact" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Get In Touch</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            I'm always interested in new opportunities and collaborations. 
            Feel free to reach out if you'd like to discuss projects, data science, or just connect!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="min-w-0">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h3>
            
            <div className="space-y-4 sm:space-y-6">
              {contactInfo.map((info, index) => (
                <a
                  key={index}
                  href={info.link}
                  target={info.link.startsWith('http') ? '_blank' : '_self'}
                  rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''}
                  className="flex items-center p-4 sm:p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group min-w-0 overflow-x-auto"
                >
                  <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r ${info.color} rounded-full flex items-center justify-center mr-4 sm:mr-6 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${info.icon === 'fa-linkedin' ? 'fab' : 'fas'} ${info.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                  <div className="min-w-0">
                    <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">{info.title}</h4>
                    <p className="text-gray-600 break-all">{info.value}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="mt-8 p-6 bg-primary-50 rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">
                <i className="fas fa-clock text-primary-600 mr-3"></i>
                Availability
              </h4>
              <p className="text-gray-700 mb-2">
                <strong>Response Time:</strong> Usually within 24 hours
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Best Time:</strong> Monday - Friday, 9 AM - 6 PM (GMT+1)
              </p>
              <p className="text-gray-700">
                <strong>Languages:</strong> Arabic, English, French
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8"></h3>
            <div className="flex items-center justify-center h-full">
              <svg width="220" height="220" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="110" cy="110" r="100" fill="#F3F4F6"/>
                <rect x="55" y="90" width="110" height="60" rx="12" fill="#6366F1"/>
                <rect x="70" y="105" width="80" height="10" rx="5" fill="#E0E7FF"/>
                <rect x="70" y="120" width="60" height="10" rx="5" fill="#E0E7FF"/>
                <circle cx="170" cy="150" r="16" fill="#A5B4FC"/>
                <rect x="100" y="145" width="40" height="8" rx="4" fill="#A5B4FC"/>
                <rect x="80" y="160" width="60" height="8" rx="4" fill="#A5B4FC"/>
                <rect x="90" y="175" width="40" height="8" rx="4" fill="#A5B4FC"/>
                <rect x="110" y="60" width="40" height="8" rx="4" fill="#A5B4FC"/>
                <rect x="70" y="75" width="60" height="8" rx="4" fill="#A5B4FC"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
